import React from "react";
import { default as WToolbar } from "@mui/material/Toolbar";

function Toolbar(props) {
  return <WToolbar {...props} />;
}

export default Toolbar;
